import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import FrenchLocale from "flatpickr/dist/l10n/fr.js";
import DutchLocale from "flatpickr/dist/l10n/nl.js";
import GermanLocale from "flatpickr/dist/l10n/de.js";
import EnglishLocale from "flatpickr/dist/l10n/uk.js";

import "../styles/form.css";

const Search = ({ option, request, language, onChange, onSearch }) => {
	const CONTRACT = "CONTRACT";
	const LICENSE = "LICENSE";

	const { t } = useTranslation();

	const [dateFormat, setDateFormat] = useState();
	const [locale, setLocale] = useState(DutchLocale);
	const [searchOption, setSearchOption] = useState(option);
	const [selectedDate, setSelectedDate] = useState();
	const [time, setTime] = useState("");
	const [trianglePosition, setTrianglePosition] = useState(0);

	const useFocus = () => {
		const htmlElRef = useRef(null);
		const setFocus = () => { htmlElRef.current && htmlElRef.current.focus(); };

		return [htmlElRef, setFocus];
	};

	const [licenseRef, setLicenseFocus] = useFocus();

	const style = { "--left-triangle": trianglePosition };

	useEffect(() => {
		setTriangle();
		setSearchOption(option);

		if (option === LICENSE)
			setLicenseFocus();
	}, [option]);

	useEffect(() => {
		if (!request.date)
			return;
		let requestDate = new Date(request.date);
		setSelectedDate(requestDate);
		setTime(request.time);
	}, [request]);

	useEffect(() => {
		const getDateFormat = () => {
			const dateFormat = t("ShortDatePattern");
			return dateFormat
				.replace("dd", "d")
				.replace("MM", "m")
				.replace("mm", "m")
				.replace("M", "m")
				.replace("yyyy", "Y")
				.replace("yy", "Y");
		};
		setTriangle();

		setDateFormat(getDateFormat());

		switch (language) {
			case "nl":
				setLocale(DutchLocale);
				break;
			case "de":
				setLocale(GermanLocale);
				break;
			case "fr":
				setLocale(FrenchLocale);
				break;
			default:
				setLocale(EnglishLocale);
		}

	}, [language, t]);

	const setTriangle = async () => {
		const getElementWidth = (e, c) => {
			let rect = e.getBoundingClientRect();
			return rect.width + c;
		};
		const options = document.querySelectorAll(".search-type-item");

		const wLicense = getElementWidth(options[0], -10);
		const wContract = getElementWidth(options[1], 20);
		const position =
			option === LICENSE
				? `${wLicense / 2}px`
				: `${wContract / 2 + wLicense}px`;

		setTrianglePosition(position);
	};

	const handleDateChange = (date) => {
		setSelectedDate(date);
		onChange("date", date);
	};

	const handleTimeChange = (time) => {

		let inputValue = time.replace(/\D/g, '');
		inputValue = inputValue.slice(0, 4);
		const parsedValue = parseInt(inputValue, 10) || 0;
		inputValue = parsedValue <= 2359 ? inputValue : '2359';

		setTime(inputValue);
		onChange('time', inputValue);
	};

	return (
		<div className="search-form" style={style}>
			<form onSubmit={onSearch}>

				<div className="search-row">
					<div className="text-wrap">
						{t(
							searchOption === LICENSE
								? "searchbylicense"
								: "searchbyrentalnumber"
						)}
					</div>
				</div>

				<div className="search-row second">
					{searchOption === CONTRACT && (
						<div className="input-wrap">
							<div className="input-field">
								<label htmlFor="contract">{t("rentalnumber")} (RA)*</label>
								<input
									id="contract"
									name="contract"
									type="text"
									onChange={(e) => onChange(e.target.name, e.target.value)}
									value={request.contract}
									autoFocus={true}
								/>
							</div>
						</div>
					)}
					<div className="input-wrap">
						<div className="input-field">
							<label htmlFor="license">{t("license")}</label>
							<input
								id="license"
								name="license"
								type="text"
								onChange={(e) => onChange(e.target.name, e.target.value)}
								value={request.license}
								ref={licenseRef} />
						</div>
					</div>

					{searchOption === LICENSE && (
						<>
							<div className="input-wrap">
								<div className="input-field">
									<label htmlFor="date">{t("offencedate")}</label>
									{locale && language && <Flatpickr
										id="date"
										name="date"
										onChange={(e) => handleDateChange(e[0])}
										options={{
											showMonths: 1,
											disableMobile: "true",
											dateFormat: dateFormat,
											locale: locale[language],
										}}
										value={selectedDate}
									/>}
								</div>
							</div>
							<div className="input-wrap">
								<div className="input-field">
									<label htmlFor="time">{t("offencetime")}</label>
									<input
										id="time"
										name="time"
										type="text"
										value={time}
										onChange={(e) => handleTimeChange(e.target.value)}
									/>
								</div>
							</div>
						</>
					)}
					<div className="footnotes">
						{searchOption === LICENSE && (
							<>

							</>)}
						{searchOption === CONTRACT && (
							<>
								<div>
									* {t("rentalnumber")} (RA) {t("or")} {t("referencenumber")}{" "}
									{t("or")} {t("last9digitsfinenumber")}
									<br />
								</div>
							</>
						)}
					</div>
				</div>

				<div className="search-row last">
					<button type="submit" className="btn-search">
						{t("search")}
					</button>
				</div>
			</form>
		</div>
	);
};

export default Search;
